const OG_TITLE =
  "Glider Developer Platform | API for Automated Portfolio Management";
const OG_DESCRIPTION =
  "Build with Glider API. Intelligent portfolio infrastructure for apps and agents at massive scale.";
const OG_IMAGE = "/api/og-image.png";

export const apiLandingHead = () => ({
  meta: [
    { title: OG_TITLE },
    { name: "description", content: OG_DESCRIPTION },
    { property: "og:title", content: OG_TITLE },
    { property: "og:description", content: OG_DESCRIPTION },
    { property: "og:image", content: OG_IMAGE },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: OG_TITLE },
    { name: "twitter:description", content: OG_DESCRIPTION },
    { name: "twitter:image", content: OG_IMAGE },
  ],
});
